import axios from "axios";
import { FARM_PRACTICES } from "../../src/configurations/Urls";
import Session from "../helpers/SessionHelper";

const CropService = {
  async updateCropDetails(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.post(FARM_PRACTICES, payload, {
      headers: headers,
    });
    return response;
  },

  async multiFieldsCropUpdate(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.post(`${FARM_PRACTICES}/multiple`, payload, {
      headers: headers,
    });
    return response;
  },

  async getCropsAndTillages() {
    const headers = await Session.getHeaderWithToken();
    const response = await axios.get(`${FARM_PRACTICES}`, {
      headers: headers,
    });
    return response;
  },
};

export default CropService;
